const Loader = () => (
  <div className="flex items-center justify-center py-16">
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-200 border-t-gray-700" />
  </div>
);

const VARIANTS = {
  default: "w-[98%] mx-auto",
  // narrow: "w-[95%] xl:w-[70%] mx-auto",
  narrow: "max-w-[1600px] mx-auto",
  xnarrow: "w-[95%] xl:w-[60%] mx-auto",
  full: "w-full",
};

const EmptyPlaceholder = ({ message = "Nothing to show here yet." }) => (
  <div className="flex flex-col items-center justify-center gap-3 py-20 text-center text-gray-400">
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M3 9h18M9 21V9" />
    </svg>
    <p className="text-sm">{message}</p>
  </div>
);

const Container = ({
  children,
  className = "",
  bg,
  style = {},
  variant = "default",
  isVisible = true,
  isLoading,
  showEmptyState = false,
  emptyState,
  emptyMessage,
  ...props
}) => {
  if (!isVisible) return null;
  const variantClass = VARIANTS[variant] ?? VARIANTS.default;
  const bgStyle = bg
    ? {
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        ...style,
      }
    : style;

  return (
    <div
      className={`${variantClass} ${className} min-h-fit transition-[min-height] duration-500`}
      style={bgStyle}
      {...props}
    >
      {isLoading
        ? <Loader />
        : showEmptyState
          ? emptyState ?? <EmptyPlaceholder message={emptyMessage} />
          : children}
    </div>
  );
};

export default Container;
